const apiServicesData = [
  {
    title: "Microservices API Development",
    description:
      "We build your system with small, independent services (microservices). This makes your entire platform faster, easier to update, and more reliable—if one small part breaks, the rest keeps working.",
    bullets: [
      "Independent Services",
      "Faster Updates",
      "Ready for the Cloud",
      "Highly Reliable",
    ],
    minHeight: 420,
  },
  {
    title: "E-commerce API Development",
    description:
      "We create the backend APIs that power smooth, secure online shopping for a seamless customer journey from browsing to payment.",
    bullets: [
      "Secure Payments",
      "Live Stock Checks",
      "Works Everywhere",
      "Personalised Shopping",
    ],
    minHeight: 420,
  },
  {
    title: "Mobile App API Development",
    description:
      "APIs tailored for mobile to ensure fast performance, quick data access, and secure transactions across iOS and Android.",
    bullets: [
      "Fast Data Loading",
      "Secure Transactions",
      "iOS & Android Ready",
      "Scales with Your Growth",
    ],
    minHeight: 420,
  },
  {
    title: "API Modernization and Optimization",
    description:
      "Upgrade legacy APIs to modern standards—faster, more secure, and easier to maintain for your team.",
    bullets: [
      "Upgrade Old Systems",
      "Major Speed Boost",
      "Stronger Security",
      "Easier to Maintain",
    ],
    minHeight: 420,
  },
  {
    title: "Third-Party API Integration",
    description:
      "Securely connect your systems to external tools like payment processors, CRMs, and social platforms.",
    bullets: [
      "Easy Tool Connections",
      "Secure Data Sharing",
      "Faster Setup",
      "Flexible Integrations",
    ],
    minHeight: 420,
  },
  {
    title: "Custom API Applications",
    description:
      "Public, partner, private, and composite APIs with SOA patterns, WebSocket support, and robust data layers.",
    bullets: [
      "Composite API Design",
      "Service-Oriented Architecture",
      "Web Socket API Integration",
      "Public API Development",
    ],
    minHeight: 420,
  },
  {
    title: "Custom API Development",
    description:
      "Secure, scalable APIs tailored to your goals—exact functions you need for reliable, long-term growth.",
    bullets: [
      "Tailored to Your Goals",
      "Strong and Stable",
      "Future-Ready Design",
      "Full Development Support",
    ],
    minHeight: 420,
  },
  {
    title: "Strategic API Consultation",
    description:
      "Personalized guidance on API strategy, tooling, and roadmaps so delivery aligns with business goals.",
    bullets: [
      "Understand Your Needs",
      "Suggest Best Tools",
      "Clear API Roadmap",
      "Expert Support Anytime",
    ],
    minHeight: 420,
  },
  {
    title: "Enterprise API Development",
    description:
      "Robust, secure APIs for large-scale needs—connect complex systems, support high-volume traffic, and meet compliance.",
    bullets: [
      "Highest Security for Data",
      "Handles Large Workloads",
      "Easy System Connections",
      "Improves Team Collaboration",
    ],
    minHeight: 420,
  },
];

// From sections/api-development/ApiAAS.jsx (left and right feature lists)
export const apiAasLeftFeatures = [
  {
    icon: "fa-solid fa-plug",
    title: "Third-Party API Integrations",
    desc: "We enhance your web capabilities by integrating with Microsoft platforms and other tools. Our services include robust web functionality, API documentation, and connecting diverse business systems via REST and other applications.",
  },
  {
    icon: "fa-solid fa-screwdriver-wrench",
    title: "API Maintenance & Support",
    desc: "Our API maintenance services ensure smooth and secure operations. We emphasize robust API architecture, encryption, single sign-on, dashboard controls, and RBAC modules.",
  },
];

export const apiAasRightFeatures = [
  {
    icon: "fa-solid fa-cloud",
    title: "Cloud Application Programming Interface Solutions",
    desc: "Compliant API solutions for secure and efficient cloud software development across SaaS, IaaS, PaaS, and APIaaS—ensuring seamless user access across platforms and devices.",
  },
  {
    icon: "fa-solid fa-diagram-project",
    title: "Microservices Consulting",
    desc: "Transform monoliths into microservices so each function can evolve independently, be customized as needed, and operate as a distinct process.",
  },
];

// From sections/api-development/ApiSupport.jsx (cards list)
export const apiSupportCards = [
  {
    icon: "fa-solid fa-code-branch",
    title: "REST API Support",
    desc: "Experts in REST APIs for JSON, XML, and HTML formatting. We optimize performance for IoT platforms and custom mobile apps and provide quick assistance and troubleshooting for all REST-based API needs.",
  },
  {
    icon: "fa-solid fa-soap",
    title: "SOAP API Support",
    desc: "Guidance and swift resolutions for WSDL/XML with SOAP APIs. We ensure secure, reliable communication between distributed systems and manage complex SOAP-related functions.",
  },
  {
    icon: "fa-regular fa-file-code",
    title: "XML API Assistance",
    desc: "Comprehensive XML API support including data validation, schema/DTD handling, error correction, and efficient data exchange across systems. We monitor XML API performance for consistency and accuracy.",
  },
  {
    icon: "fa-solid fa-diagram-project",
    title: "RPC API Services",
    desc: "Specialized RPC API support for remote/hybrid environments. We improve network communication and resolve serialization/deserialization issues of RPC payloads efficiently.",
  },
];

export default apiServicesData;
